import { ca } from '@cian/analytics';

export function trackDocumentClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'download_doc',
    label: '',
    useLastProducts: true,
  });
}
